import { apiClient } from './client'
export type SetupClient = 'codex' | 'claude-desktop' | 'opencode'
export interface SetupCommand {
  command: string
  powershellCommand: string
  expiresAt: string
}
export interface McpInstallation {
  id: number
  name: string
  client: SetupClient
  tokenPrefix: string
  createdAt: string
  lastUsedAt: string | null
}
export const createSetupCommand = (client: SetupClient, name: string) =>
  apiClient.post<SetupCommand>('/mcp/setup/tokens', { client, name })
export const listInstallations = () =>
  apiClient.get<{ installations: McpInstallation[] }>('/mcp/setup/installations')
export const revokeInstallation = (id: number) =>
  apiClient.post<{ revoked: boolean }>(`/mcp/setup/installations/${id}/revoke`)
